/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable fp/no-mutating-methods */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
import { format } from 'date-fns'

import { ActivityChartStatstResponse } from '~/redux/apis/user-stats-api'

export interface AttemptsFormattedData {
  attemptValues: Array<string | null>
  attemptDates: Array<string | null>
  bestAttemptItem: {}
}

export const getAttemptsFormattedData = (attempts: ActivityChartStatstResponse['attempts']): AttemptsFormattedData => {
  if (attempts) {
    const attemptValues = []
    const attemptDates = []
    let bestAttemptItem: { data: number; index: number } = {
      data: 0,
      index: 0,
    }

    attempts.forEach((attempt: { accuracy: any; date: any }, index: number) => {
      const accuracy = Math.floor(attempt.accuracy * 100)
      const formattedDate = format(new Date(attempt.date), 'yyyy-MM-dd')

      attemptValues.push(accuracy)
      attemptDates.push(formattedDate)

      if ((bestAttemptItem && bestAttemptItem.data < accuracy) || !bestAttemptItem) {
        bestAttemptItem = { index: index + 1, data: accuracy }
      }
    })

    attemptValues.unshift(null)
    attemptValues.push(null)

    attemptDates.unshift('')
    attemptDates.push('')

    return {
      attemptValues,
      attemptDates,
      bestAttemptItem,
    }
  }

  return {
    attemptValues: [],
    attemptDates: [],
    bestAttemptItem: {},
  }
}
